/* eslint-disable */
import React, { ReactNode } from 'react';
import { PrismicSliceType } from '@tcs/create-account/utils/prismic/types';
import { SlicesIdentity } from '@tcs/create-account/utils/prismic/enums';
import CtaButton from '@tcs/create-account/components/slices/CtaButton';
import FramedText from '@tcs/create-account/components/slices/FramedText';
import Intro from '@tcs/create-account/components/slices/Intro';
import Text from '@tcs/create-account/components/slices/Text';
import IconLinks from '@tcs/create-account/components/slices/IconLinks';

interface SlicePickerProps {
  list: PrismicSliceType<any, any>[];
}

const SlicePicker: React.FC<SlicePickerProps> = ({ list }) => {
  if (!list.length) return null;

  const getSlice: (
    slice: PrismicSliceType<any, any>,
    index: number
  ) => ReactNode | undefined = (slice, index) => {
    const { primary, items, slice_type } = slice;
    const { CTA_BUTTON, FRAMED_TEXT, ICON_LINKS, INTRO, TEXT } = SlicesIdentity;
    const slices: { [index: string]: ReactNode } = {
      [CTA_BUTTON]: <CtaButton data={primary} key={index} />,
      [FRAMED_TEXT]: <FramedText data={primary} key={index} />,
      [ICON_LINKS]: <IconLinks data={primary} items={items} key={index} />,
      [INTRO]: <Intro data={primary} key={index} />,
      [TEXT]: <Text data={primary} key={index} />,
    };
    return slices[slice_type];
  };

  const slices = list.map((item, index) => getSlice(item, index));

  return <>{slices}</>;
};

export default SlicePicker;
